module.exports = __webpack_public_path__ + "img/map.7826d7da.png";